module.exports = __webpack_public_path__ + "img/bigb.07791668.png";